// extracted by mini-css-extract-plugin
export default {"plugin-menu-root":"eJr8_","pluginMenuRoot":"eJr8_"};